<template>
    <div
        id="data-list-list-view"
        class="data-list-container"
        v-if="couponsBatch"
    >
        <CouponsBatchTable
            :data="couponsBatch"
            :itemsPerPage="itemsPerPage"
            @itemsPerPage="setItemsPerPage"
            @search="search"
            @limit="setLimit"
            @sort="setSort"
            @selectedBatch="setSelectedBatch"
            @createNewBatch="createNewBatch"
        ></CouponsBatchTable>
        <vs-pagination
            :total="couponsBatch.number_of_pages"
            v-model="pageNumber"
        ></vs-pagination>
        <CouponBatchModal
            :show="show.couponBatchModal"
            :batch="selectedBatch"
            @close="closeCouponBatchModal"
            @refresh="getPage"
        />
        <CouponBatchCreateModal
            :show="show.couponBatchCreateModal"
            @close="show.couponBatchCreateModal = false"
            @refresh="getPage"
        />
    </div>
</template>

<script>
import CouponsBatchTable from './CouponsBatchTable'
import CouponBatchModal from './CouponBatchModal'
import CouponBatchCreateModal from './CouponBatchCreateModal'
import { http } from '@/services'

export default {
    name: 'CouponsBatchAll',
    components: {
        CouponsBatchTable,
        CouponBatchModal,
        CouponBatchCreateModal,
    },
    created() {
        if (this.$route.params.page)
            this.pageNumber = Number(this.$route.params.page)
        this.getPage()
    },
    beforeRouteUpdate(to, from, next) {
        next()
        if (this.$route.params.page)
            this.pageNumber = Number(this.$route.params.page)
        this.getPage()
    },
    watch: {
        pageNumber(newValue, oldValue) {
            if (Number(newValue) !== Number(oldValue))
                this.$router.push({
                    name: 'couponsBatch',
                    params: { page: Number(newValue) },
                })
        },
    },
    computed: {
        couponsData() {
            if (this.couponsBatch && this.couponsBatch.data)
                return this.couponsBatch.data
            return []
        },
    },
    data() {
        return {
            couponsBatch: null,
            pageNumber: 1,
            itemsPerPage: 10,
            selected: null,
            queriedItems: 20,
            limit: 'all',
            sort: null,
            selectedBatch: null,
            show: {
                couponBatchModal: false,
                couponBatchCreateModal: false,
            },
        }
    },
    methods: {
        setItemsPerPage(value) {
            this.itemsPerPage = value
            this.getPage()
        },
        setPageNumber(value) {
            this.pageNumber = value
            this.getPage()
        },
        getPage(searchQuery = null) {
            http.get('coupons_batch_list', {
                params: {
                    limit: this.limit,
                    items_per_page: this.itemsPerPage,
                    page_number: this.pageNumber,
                    query: searchQuery,
                    sort: this.sort,
                },
            })
                .then((response) => {
                    this.couponsBatch = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        search(value) {
            this.getPage(value)
        },
        setLimit(value) {
            this.limit = value
            this.getPage()
        },
        setSort(value) {
            this.sort = value
            this.getPage()
        },
        setSelectedBatch(value) {
            this.selectedBatch = value
            this.show.couponBatchModal = true
        },
        closeCouponBatchModal() {
            this.show.couponBatchModal = false
            this.selectedBatch = null
        },
        createNewBatch() {
            console.log('create new batch')
            this.selectedBatch = null
            this.show.couponBatchCreateModal = true
        },
    },
}
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {
        /*
              Below media-queries is fix for responsiveness of action buttons
              Note: If you change action buttons or layout of this page, Please remove below style
            */
        @media (max-width: 689px) {
            .vs-table--search {
                margin-left: 0;
                max-width: unset;
                width: 100%;

                .vs-table--search-input {
                    width: 100%;
                }
            }
        }

        @media (max-width: 461px) {
            .items-per-page-handler {
                display: none;
            }
        }

        @media (max-width: 341px) {
            .data-list-btn-container {
                width: 100%;

                .dd-actions,
                .btn-add-new {
                    width: 100%;
                    margin-right: 0 !important;
                }
            }
        }

        .product-name {
            max-width: 23rem;
        }

        .vs-table--header {
            display: flex;
            flex-wrap: wrap;
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            > span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    & + i {
                        left: 1rem;
                    }

                    &:focus + i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                td {
                    padding: 20px;
                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }
                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }
                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }
            th.td-check {
                padding: 0 15px !important;
            }
            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }
    }
}
</style>
